// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"e4a60ff6","367":"e4a60ff6","706":"625117fb","750":"e4a60ff6","966":"2c90fad3"}[chunkId] + ".chunk.css";
};